import { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import {
  Box,
} from '@material-ui/core';

import closeIcon from '../images/closeIcon.svg';
import notifConfirmIcon from '../images/notifConfirmIcon.svg';
import notifAlertIcon from '../images/notifAlertIcon.svg';
import notifErrorIcon from '../images/notifErrorIcon.svg';

import DashboardNavbarAdminClient from './DashboardNavbarAdminClient';
import DashboardNavbar from './DashboardNavbar';

import PopupNotifContext from "../contexts/PopupNotifContext"
import LanguageContext from "../contexts/LanguageContext"

import { getCurrentUser } from "../utils/auth"

const DashboardLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: 'theme.palette.background.default',
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    fontFamily: 'Questrial',
  })
);

const DashboardLayoutWrapper = styled('div')(
  ({ hidenavbar, theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: hidenavbar === "true" ? "0" : "65px",
    [theme.breakpoints.down('sm')]: {
      paddingTop: hidenavbar === "true" ? "0" : "55px",
    }
  })
);

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = styled('div')(
  ({ theme }) => ({
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    backgroundColor: '#FAF8F6',
  })
);

const DashboardLayout = ( {hideNavbar, menuforadmin, children} ) => {

  const { notifs, haveToDisplay, removeByUUID, errorLogin } = useContext(PopupNotifContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  let currentUser = getCurrentUser()

  return (
    <DashboardLayoutRoot>

      {errorLogin &&
        <div style={{zIndex:9999999999, userSelect:"none", fontSize:"2em", textAlign:"center", color:"white", background:"rgba(0,0,0,0.9)", position:"absolute", top:0, left:0, width:"100%", height:"100vh", display:"flex", alignItems:"center", justifyContent:"center"}}>
          {languageValues?.authError[actLanguage]}
        </div>
      }

      {haveToDisplay !== null &&
        <Box
          sx={{
            position:"absolute",
            top:["0px", "unset", "unset"],
            bottom:["unset", "15px", "15px"],
            left:["0px", "25px", "25px"],
            width:["calc(100%)", "calc(100% - 50px)", "calc(100% - 50px)"],
            zIndex:99999999,
            display:"flex",
            justifyContent:["center", "flex-end", "flex-end"],
            userSelect:"none",
          }}
        >
          <Box
            onClick={() => {
              removeByUUID(haveToDisplay?.uuid)
            }}
            sx={{
              cursor:"pointer",
              background:"white",
              border:["0", "1px solid black"],
              borderBottom:"1px solid black !important",
              boxShadow: "2px 2px 12px 1px rgba(0, 0, 0, 0.25)",
              padding:"15px",
              display:"flex",
              justifyContent:"space-between",
              alignItems:"center",
              gap:"15px",
              height:["70px"],
              width: ["100%", "350px"],
            }}
          >
            <Box sx={{
              display:"flex",
              overflow:"hidden",
              gap:"10px",
            }}>
              {haveToDisplay?.type === "confirm" &&
                <img
                  src={notifConfirmIcon}
                  style={{width:"30px", height:"30px", cursor:"pointer"}}
                />
              }
              {haveToDisplay?.type === "alert" &&
                <img
                  src={notifAlertIcon}
                  style={{width:"30px", height:"30px", cursor:"pointer"}}
                />
              }
              {haveToDisplay?.type === "error" &&
                <img
                  src={notifErrorIcon}
                  style={{width:"30px", height:"30px", cursor:"pointer"}}
                />
              }
              <Box sx={{
                overflow:"hidden",
                display:"flex",
                flexDirection:"column",
                gap:"3px",
                alignItems:"flex-start",
                justifyContent:"center",
              }}>
                <Box sx={{
                  whiteSpace:"noWrap",
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  fontSize:"15px",
                  color:"text.black",
                  maxWidth:"100%",
                }}>
                  {haveToDisplay?.title}
                </Box>
                {haveToDisplay?.subTitle &&
                  <Box sx={{
                    whiteSpace:"noWrap",
                    overflow:"hidden",
                    textOverflow:"ellipsis",
                    fontSize:"14px",
                    color:"text.subTitle",
                    maxWidth:"100%",
                  }}>
                    {haveToDisplay?.subTitle}
                  </Box>
                }
              </Box>
            </Box>
            <Box>
              <img
                src={closeIcon}
                style={{width:"12px", height:"12px", cursor:"pointer"}}
              />
            </Box>
          </Box>
        </Box>
      }
      {currentUser?.type === "adminclient" &&
        <DashboardNavbarAdminClient />
      }
      {(currentUser?.type === "student" && hideNavbar !== true) &&
        <DashboardNavbar menuforadmin={menuforadmin}/>
      }
      <DashboardLayoutWrapper hidenavbar={hideNavbar?.toString()}>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            {children}
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
